export default class UnauthorizedError extends Error {
  code: number;
  name: string;

  constructor(message: string) {
    super(message);
    this.code = 401;
    this.name = 'UnauthorizedError';
  }
}
